(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name AppController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('AppController', AppController);

    AppController.$inject = [];

    function AppController()
    {
        var vm = this;

              
    }


})();